import Avatar from "@/components/ui/Avatar";
import { HiOutlineCalendar, HiOutlineClipboardCheck } from "react-icons/hi";
import { TbVideo } from "react-icons/tb";
import { AdmUserNotificationsApi$LatestNotificationType } from "@/custolink-transpiled_by_server/bc.identity_and_access.api_methods";
import { FaRobot } from "react-icons/fa";

const NotificationAvatar = (p: {
  type: AdmUserNotificationsApi$LatestNotificationType;
}) => {
  switch (p.type) {
    case AdmUserNotificationsApi$LatestNotificationType.AssetAiConversation:
      return (
        <Avatar
          shape="circle"
          className="bg-sky-200 text-gray-900"
          icon={<FaRobot />}
        />
      );
    case AdmUserNotificationsApi$LatestNotificationType.Inquiry:
      return (
        <Avatar
          shape="circle"
          className="bg-sky-200 text-gray-900"
          icon={<HiOutlineCalendar />}
        />
      );
    case AdmUserNotificationsApi$LatestNotificationType.ProductRegistered:
      return (
        <Avatar
          shape="circle"
          className="bg-sky-200 text-gray-900"
          icon={<HiOutlineClipboardCheck />}
        />
      );
    case AdmUserNotificationsApi$LatestNotificationType.AssetVideoCall:
      return (
        <Avatar
          shape="circle"
          className="bg-sky-200 text-gray-900"
          icon={<TbVideo />}
        />
      );
    default:
      return null;
  }
};

export default NotificationAvatar;
